interface CandidatePreviewSkill {
  id?: string;
  skillName: string;
  skillLevel?: string;
}

const skillLevelPriority: Record<string, number> = {
  expert: 0,
  advanced: 1,
  intermediate: 2,
  beginner: 3,
};

const previewSkillPriority = (skill: CandidatePreviewSkill) =>
  skillLevelPriority[skill.skillLevel?.trim().toLowerCase() || ''] ?? 4;

export function getCandidatePreviewSkills<T extends CandidatePreviewSkill>(
  skills: T[] = [],
  limit = 10
): T[] {
  if (limit <= 0) return [];

  return [...skills]
    .sort(
      (left, right) =>
        previewSkillPriority(left) - previewSkillPriority(right) ||
        left.skillName.localeCompare(right.skillName, undefined, {
          sensitivity: 'base',
        })
    )
    .slice(0, limit);
}
